import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { api, gbp, num, YEARS } from "@/lib/api";
import { PageHeader, Panel, StageBadge } from "@/components/tam/ui";

export default function ProductDetail() {
  const { code } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/products/${encodeURIComponent(code)}`).then((r) => setP(r.data)); }, [code]);
  if (!p) return <p className="text-slate-500">Loading product…</p>;
  const chart = YEARS.map((y) => ({ year: y, value: p.years[y]?.value || 0 }));

  return (
    <div data-testid="product-detail-page">
      <Link to="/products" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-[#D9232A] mb-4"><ArrowLeft size={14} /> Products</Link>
      <PageHeader title={p.description} subtitle={`Code ${p.code} · ${p.customers} customers · ${num(p.total_qty)} units · ${gbp(p.total_value)}`} />
      <div className="grid lg:grid-cols-12 gap-6">
        <Panel title="Value by year" className="lg:col-span-5">
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%" minWidth={0} minHeight={200}>
              <BarChart data={chart}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" />
                <XAxis dataKey="year" tick={{ fontSize: 12 }} /><YAxis tick={{ fontSize: 11 }} />
                <Tooltip formatter={(v) => gbp(v)} />
                <Bar dataKey="value" fill="#D9232A" radius={[3, 3, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Panel>
        <Panel title="Customers who bought this" className="lg:col-span-7" testId="product-customers">
          <table className="w-full text-sm">
            <tbody>
              {p.customer_list.map((c) => (
                <tr key={c.id} className="border-b border-slate-100">
                  <td className="py-2"><Link to={`/accounts/${c.id}`} className="hover:text-[#D9232A] font-medium">{c.name}</Link><p className="text-xs text-slate-500">{c.acc_no} · {c.owner}</p></td>
                  <td className="py-2"><StageBadge stage={c.stage} /></td>
                  <td className="py-2 text-right font-mono text-xs text-slate-500">{num(c.total_qty)} qty</td>
                  <td className="py-2 text-right font-mono">{gbp(c.total_value)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Panel>
      </div>
    </div>
  );
}
